import {Graphics, RenderTexture, SimpleMesh, Texture} from 'pixi.js';
import {PixiApplicationController} from '../../../../../../controllers/PixiApplicationController';

export class CardBetween extends SimpleMesh
{
    private static mockupTexture: RenderTexture;
    private widthHalf: number;
    private hei: number;

    constructor(widthHalf: number, hei: number) {
        let vertices: number[] = [
            -widthHalf, 0,
            widthHalf, 0,
            -widthHalf, hei,
            widthHalf, hei
        ];

        let uvs: number[] = [
            0, 0,
            1, 0,
            0, 1,
            1, 1
        ];

        let indices: number[] = [
            0, 1, 2,
            1, 2, 3
        ];

        super(CardBetween.getMockup(8, 8), new Float32Array(vertices), new Float32Array(uvs), new Float32Array(indices));
        this.widthHalf = widthHalf;
        this.hei = hei;
    }

    private static getMockup(width: number, height: number): Texture {
        if (CardBetween.mockupTexture) {
            return CardBetween.mockupTexture;
        }
        let renderTexture: RenderTexture = RenderTexture.create({width, height});
        let graphics: Graphics = new Graphics();
        graphics.beginFill(0x555555);
        graphics.drawRect(0, 0, width, height);
        graphics.endFill();
        PixiApplicationController.app.renderer.render(graphics, {renderTexture});
        CardBetween.mockupTexture = renderTexture;
        return CardBetween.mockupTexture;
    }

    setVertices(vertices: number[]) {
        this.verticesBuffer.update(vertices);
    }
}
